export function copyTextToClipboard(text) {
  if (!document) throw Error('document must exist.');
  const textarea = document.createElement('textarea');
  textarea.style.position = 'fixed';
  textarea.style['z-index'] = '-10000';
  textarea.textContent = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  window.getSelection().removeAllRanges();
  document.body.removeChild(textarea);
}